<template>
  <div class="flex flex-col">
    <router-view v-slot="slotProps">
      <component :is="slotProps.Component"></component>
    </router-view>
  </div>
</template>

<style>
flt-semantics-placeholder {
  display: none !important;
  z-index: 0 !important;
}
</style>

<script>
import { onMounted } from 'vue';

export default {
  setup() {
    onMounted(() => {
      let intervalCount = 0;
      const interval = setInterval(() => {
        const placeholder = document.querySelector('flt-semantics-placeholder');
        if (placeholder) {
          placeholder.remove();
          console.log('flt-semantics-placeholder found and removed');
          clearInterval(interval);
        }
        intervalCount++;
        if (intervalCount > 10) {
          console.log('flt-semantics-placeholder not found');
          clearInterval(interval);
        }
      }, 1000);
    });
  },
};
</script>
